import React from 'react';
import { Menu, Typography, MenuItem, Box } from '@mui/material';
import theme from '../../theme';

const CustomMenu = ({
  anchorEl,
  open,
  onClose,
  items = [],
  anchorOrigin = { vertical: 'bottom', horizontal: 'right' },
  transformOrigin = { vertical: 'top', horizontal: 'right' },
  paperProps = {},
}) => {
  const defaultPaperProps = {
    sx: {
      '& .MuiList-root': {
        p: 1,
      },
      boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.2)',
      ...paperProps.sx,
    },
  };

  return (
    <Menu
      anchorEl={anchorEl}
      open={open}
      onClose={onClose}
      anchorOrigin={anchorOrigin}
      transformOrigin={transformOrigin}
      PaperProps={defaultPaperProps}
    >
      {items.map((item, index) => (
        <MenuItem
          key={index}
          onClick={item.onClick}
          disableRipple
          selected={false}
          sx={{
            display: 'flex',
            alignItems: 'center',
            px: 2,
            py: 1.5,
            gap: item.icon || item.iconNode ? 0.75 : 0,
            backgroundColor: 'transparent !important',
            '&:hover': {
              backgroundColor: `${theme.palette.grey.bg} !important`,
            },
            ...item.sx,
          }}
        >
          {item.icon && (
            <img
              src={item.icon}
              alt={item.iconAlt || ''}
              style={{ width: '16px', height: '16px' }}
            />
          )}
          {item.iconNode && (
            <Box
              component="span"
              sx={{
                width: 16,
                height: 16,
                display: 'inline-flex',
                alignItems: 'center',
                justifyContent: 'center',
                color: theme.palette.black[4],
                '& svg': {
                  fontSize: 16,
                },
              }}
            >
              {item.iconNode}
            </Box>
          )}
          <Box sx={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
            <Typography fontSize={16} color={theme.palette.black[6]}>
              {item.text}
            </Typography>
            {item.badge && (
              <Box
                sx={{
                  width: 16,
                  height: 16,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              >
                <Box
                  sx={{
                    width: 8,
                    height: 8,
                    borderRadius: '4px',
                    backgroundColor: theme.palette.secondary.main,
                  }}
                />
              </Box>
            )}
          </Box>
        </MenuItem>
      ))}
    </Menu>
  );
};

export default CustomMenu;
